import { fetchToken } from "../../../common/FetchCookie";
import { ADMIN, BASE_URL, STATE } from "../../../common/URLs";

export const fetchStateList = async (page) => {
  const url = `${BASE_URL}/${ADMIN}/${STATE}?page=${page}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",

        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addState = async (newState) => {
  const url = `${BASE_URL}/${ADMIN}/${STATE}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newState),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteState = async (uuid) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${ADMIN}/${STATE}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting : " + error.message);
  }
};

export const updateState = async (uuid, StateData) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${BASE_URL}/${ADMIN}/${STATE}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(StateData),
    });

    if (!response.ok) {
      throw new Error("Error updating : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating : " + error.message);
  }
};
